import {
  observable, flow, action, makeObservable,
} from 'mobx';

import BaseStore from './BaseStore';
import SchoolReviewAPI from '../api/school_review';

class SchoolReviewStore extends BaseStore {
  isSent = false;
  isRefSent = false;
  placeId = '';
  rating = 0;
  reviewId = '';

  constructor() {
    super();

    makeObservable(this, {
      isSent: observable,
      isRefSent: observable,
      placeId: observable,
      rating: observable,
      setPlaceId: action.bound,
      setRating: action.bound,
      resetReviewStore: action.bound,
    });
  }

  setPlaceId(googlePlaceId) {
    this.placeId = googlePlaceId;
  }

  setRating(amount) {
    this.rating = amount;
  }

  create = flow(function* (payload, setErrors, setStatus, setSubmitting, recaptchaToken) {
    try {
      const { data } = yield SchoolReviewAPI.create({
        review: payload,
        new_google_recaptcha_token: recaptchaToken,
      });
      this.isSent = true;
      this.reviewId = data.id;
    } catch (e) {
      if (e.response && e.response.data && e.response.data.errorMessages) {
        setErrors(e.response.data.errorMessages);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
        setStatus({ success: false });
      }
      setSubmitting(false);
    }
  });

  createReferral = flow(function* (payload, setErrors, setStatus, setSubmitting) {
    try {
      const { data } = yield SchoolReviewAPI.createReferral(payload);
      this.isRefSent = true;
      this.reviewId = data.id;
    } catch (e) {
      if (e.response && e.response.data && e.response.data.errorMessages) {
        setErrors(e.response.data.errorMessages);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
        setStatus({ success: false });
      }
      setSubmitting(false);
    }
  });

  resetReviewStore() {
    this.reviewId = '';
    this.placeId = '';
    this.rating = 0;
  }
}

export default new SchoolReviewStore();
